<form *ngIf="fields && form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" (submit)="save()">

  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">

    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'channel.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'channel.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/channel" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>

    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }} </span>
          <input type="text" pInputText class="fieldInput" formControlName="description"/>
          <!-- MESSAGGI DI ERRORE -->
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.description"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.channel_code.nullable}">{{ fields.channel_code.keyName }} </span>
          <input type="text" pInputText class="fieldInput" formControlName="channel_code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.channel_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.default_store_id.nullable}">{{ fields.default_store_id.keyName }} </span>
          <p-dropdown [options]="stores" [filter]="true" formControlName="default_store_id">
            <ng-template let-store pTemplate="item">
              <div class="ui-helper-clearfix">
                <div>{{ store.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.default_store_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.default_acm_id.nullable}">{{ fields.default_acm_id.keyName }}</span>

          <p-dropdown [filter]="true" [options]="acmDropdownList" formControlName="default_acm"
            [style]="{ width: '100%' }" placeholder="{{ fields.default_acm_id.keyName }}">
          </p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.default_acm_id"></app-validation-msg>

        </div>


      </div>
    </div>

  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-channel/form-channel-loyalty/form-channel-loyalty.component.html